import merInfo from './en/information';

export default {
    'side.tittel': 'Personal data',
    'side.tilbake': 'Back',
    'side.slett': 'Delete',
    'side.slett.kontaktadresse': ' Delete contact address',
    'side.bekreft': 'Confirm',
    'side.lagre': 'Save',
    'side.avbryt': 'Cancel',
    'side.leggtil': 'Add',
    'side.leggtil.kontaktinformasjon': 'Add a phone number in the Nav registry',
    'side.valgfritt': ' (optional)',
    'side.organisasjonsnummer': 'Organisation number {orgnr}',
    'side.endre': 'Change',
    'side.endre.alle.opplysninger': 'Change information',
    'side.endre.kontaktinformasjon': 'Change contact information',
    'side.endre.adresser': 'Change addresses',
    'side.endre.kontonummer': 'Change account number',
    'side.endretil': 'Change to',
    'side.opphor': 'Termination',
    'anker.lenkehit': 'Link',
    'brodsmulesti.minside': 'My page',
    'brodsmulesti.dinepersonopplysninger': 'Personal data',
    'brodsmulesti.arbeidsforhold': 'Employment relationship',
    'header.hello': 'Hi!',
    'header.hello.name': 'Hi {name}!',
    'header.description': '<a>Read about privacy protection in the Norwegian Labour and Welfare Administration (Nav) here.</a> (text in norwegian)',
    'header.obs':
        'Here you can see the information that Nav has registered about you. You have the right to access personal data that Nav has registered about you, but you may not find all personal data here. It may be due to both technical and legal limitations.',
    'personalia.tittel': 'Personal data',
    'personalia.beskrivelse':
        'We need to know who you are and how we can contact you. If you are going to receive services or apply for financial support, we need information to assess what you are entitled to. In order to send you payments, we need your account number and an address.',
    'personalia.first_name': 'First name',
    'personalia.first_and_middle_name': 'First and middle name(s)',
    'personalia.surname': 'Last name',
    'personalia.fnr': 'National identity number',
    'personalia.dnr': 'D-number',
    'personalia.foreign_id': 'Foreign ID',
    'personalia.email': 'E-mail',
    'personalia.language': 'Language',
    'personalia.citizenship': 'Citizenship',
    'personalia.birthplace': 'Birthplace',
    'personalia.spesreg': 'Special registration',
    'personalia.civil_status': 'Marital status',
    'personalia.security_measure': 'Security measures',
    'personalia.gender': 'Gender',
    'personalia.customized_comm': 'Customised communication',
    'personalia.source.folkeregisteret': 'Source: National Population Register',
    'personalia.source.nav': 'Source: Nav',
    'personalia.source.dkif': 'Source: Contact and Reservation Register',
    'personalia.link.folkeregisteret': 'Change in National Population Register',
    'personalia.link.folkeregisteret.adresse': 'Change address in National Population Register',
    'personalia.link.brukerprofil.endre': 'Change in Your Profile',
    'personalia.link.brukerprofil.leggtil': 'Add to Your Profile',
    'personalia.link.dkif.endre': 'Do you want to change the information in Contact and Reservation Register? ',
    'personalia.link.dkif.leggtil': 'Go to the Contact and Reservation Register ',
    'personalia.kontonr': 'Account number',
    'personalia.kontonr.feilmelding': 'An error occurred while trying to get account information. Please try again later.',
    'personalia.iban': 'IBAN',
    'personalia.kontonrelleriban': 'Account number / IBAN',
    'personalia.kontonr.oveskrift': 'Account number we make payments to',
    'personalia.kontonr.ingenData': 'We have not registered your account number. <br></br>You can register your account number by clicking "Add"',
    'personalia.bank': 'Bank',
    'personalia.valuta': 'Currency',
    'personalia.bickode': 'BIC / SWIFT code',
    'personalia.bankkode': 'Bank code',
    'personalia.tlfnr': 'Phone',
    'personalia.tlfnr.oveskrift': 'Phone number registered with Nav',
    'personalia.tlfnr.ingenData': `Would you instead like to add a phone number to <b>the Nav registry</b>?
  The new phone number you add will only be stored and used by Nav.`,
    'personalia.tlfnr.telefon': 'Phone {x}',
    'personalia.tlfnr.slett.overskrift': 'Remove phone number',
    'personalia.tlfnr.slett.alert': 'Are you sure you want to remove this number?',
    'personalia.tlfnr.paagaaendeendring.feilmelding': 'We are working on registering the phone number you have added. It will soon be visible!',
    'personalia.spraak': 'Language',
    'personalia.dkif.overskrift': 'Information from the Contact and Reservation Register',
    'personalia.dkif.beskrivelse':
        'The Contact and Reservation Register is a joint national register. Nav must have your contact information in this register in order to send you messages and documents electronically.',
    'personalia.dkif.ingenData': '<b>No information registered</b>',
    'adresse.tittel': 'Addresses',
    'adresse.beskrivelse': `Below you see the types of addresses it is possible to register in the National Population Register. You can have several address types registered at the same time. You can change addresses in the National Population Register at the Tax Administration.<br></br><br></br>
<b>Home address</b> <br></br> 
The address where you are officially registered as a resident.<br></br><br></br>
<b>Temporary residential address</b><br></br> 
An address that you are currently staying at.<br></br><br></br>
<b>Postal address (contact address)</b><br></br> 
An address where you can be reached by post.<br></br> <br></br> 
<b>Shared housing</b><br></br> 
A child who lives permanently with both mother and father can have two home addresses, one of which is registered under shared housing.`,
    'adresse.oppholdsadresse': 'Temporary residential address',
    'adresse.oppholdsadresse.militaer': 'Military',
    'adresse.oppholdsadresse.utenriks': 'Abroad',
    'adresse.oppholdsadresse.paasvalbard': 'Svalbard',
    'adresse.oppholdsadresse.pendler': 'Commuter',
    'adresse.deltbosted': 'Shared housing',
    'adresse.bostedsadresse': 'Home address',
    'adresse.bostedsadresse.apneTekst': 'View details',
    'adresse.bostedsadresse.lukkTekst': 'Hide details',
    'adresse.kontaktadresse': 'Postal address (contact address)',
    'adresse.kontaktadresse.utenlandsk': 'Postal address (contact address abroad)',
    'adresse.kontaktadresse.norsk': 'Postal address (Norwegian contact address)',
    'adresse.kontaktadresse.nav': 'Contact address registered with Nav',
    'adresse.kontaktadresse.leggtil.folkeregisteret': 'Change address in National Population Register.',
    'adresse.utenlandskadresse': 'Contact address abroad',
    'adresse.postadresse': 'Postal address',
    'adresse.adressetillegg': 'Additional address',
    'adresse.gate': 'Street',
    'adresse.postnummer': 'Postal code',
    'adresse.poststed': 'Postal district',
    'adresse.dato': 'Date of move',
    'adresse.dato.gyldigtil': 'Valid until',
    'adresse.kommune': 'Municipality',
    'adresse.bolignummer': 'Unit number',
    'adresse.land': 'Country',
    'adresse.overskrift': 'Addresses registered in the National Population Register',
    'adresse.overskrift.ovrige': 'Other registered addresses',
    'adresse.ikke.registrert': 'You do not have a registered home address in the National Population Register',
    'adresse.slett.alert':
        'Do you want to remove the contact address and use the address registered with the National Population Register <br></br> to receive mail from Nav?',
    'adresse.hjelpetekster.adressetyper':
        '<p>Postal address contains street name, street number, and postal code.</p><p>Mailbox address refers to a mailbox at a post office or Post i Butikk (Post-in-Shop).</p>',
    'adresse.hjelpetekster.gyldigtil':
        '<p>You choose how long the address is to be valid, a maximum of 1 year. After 1 year, you need to change or extend the address.</p>',
    'adresse.hjelpetekster.co': `<p>Are you temporarily staying at another person's address and want the post to go there? If so, the post
    must be marked with the other person's name. This even more important if your name is not on the mailbox.</p>`,
    'adresse.hjelpetekster.bolignummer': '<p>Unit number is part of the address if you live in a flat in a multi-unit building.</p>',
    'adresse.hjelpetekster.bygningetasjeleilighet':
        '<p>To be filled out if the address contains information about the building. Examples include flat number, entrance, suite, name of building and floor.</p>',
    'adresse.hjelpetekster.regiondistriktomraade':
        '<p>To be filled out if the address contains name of region or area. Examples are district, state, and village.</p>',
    'adresse.hjelpetekster.utenlandsk.adresse':
        '<p>If it is not possible to separate the region, building, postal code or place name from the address, fill in the full address in the address field, as given. The information should not be listed anywhere else.</p>',
    'adresse.hjelpetekster.tilleggsnavn':
        '<p>Additional address name is an addition to the official address.</p><p>For example, this may be a farm name, known institutions/buildings, hamlets, housing estates, cottage areas, etc.</p>',
    'arbeidsforhold.tittel': 'Employment relationship',
    'arbeidsforhold.beskrivelse':
        '<p>Nav needs information about your employment relationships in order to assess your need for follow-up and services from Nav, and to calculate how much you can receive for, for example, sickness benefit, unemployment benefit and parental benefit. Other government agencies also have access to information from the State Register of Employers and Employees.</p><p>The Norwegian Labour and Welfare Administration (Nav) owns and manages the State Register of Employers and Employees (Aa-registeret).<br></br><lenkeAaRegisteret>Read more about the State Register of Employers and Employees</lenkeAaRegisteret></p>',
    'arbeidsforhold.kilde': 'Source: State Register of Employers and Employees<br></br><span>The data is reported by employers</span>',
    'arbeidsforhold.disclaimer':
        'The overview shows all employment relationships reported after 1 January 2015.<br></br>If there are errors in an employment relationship, the employer can change it through the a-melding (employee and payroll reporting).',
    'arbeidsforhold.submitted.by': 'The data is reported by the employer',
    'utbetalinger.tittel': 'Account number for payment',
    'utbetalinger.hjelpetekster.kontonummer':
        '<p>When you receive benefits from Nav, you must provide a bank account that is in your name. The address registered by Nav under your name must be identical to the one you have provided to the foreign bank. </p><p>For payments to European banks, IBAN is required. IBAN always starts with two initial letters without spaces, followed by between 15 and 31 numbers, depending on the requirements of each country. Example: DK12389325974125698</p><p>If you provide an IBAN number, you must provide a BIC.</p><p>Account numbers that are not IBANs may have a BIC.</p>',
    'utbetalinger.hjelpetekster.bic':
        '<p>BIC/SWIFT is an international system used to identify banks. Your bank will provide you with the BIC. The BIC/SWIFT code consists of 8 or 11 letters.</p><p>If you have a European bank account, you must provide both the BIC code and IBAN.</p><p>If the country uses a bank code, you must provide the BIC for the banks that have BIC.</p>',
    'utbetalinger.hjelpetekster.valuta': `<p>Fees may be lower if you choose payment in the currency of the country in which you have settled.
    Check with the bank to see what is best for you. If you have an account associated with a specific currency (currency account), you
    state this currency to Nav.</p><p>If you can't find the currency on the list, you can select a main currency: US dollar (USD) or euro (EUR).</p>`,
    'utbetalinger.hjelpetekster.bankkode':
        '<p>In this field, fill out the bank code, Fedwire number (FW), or routing number.</p><p>If you enter a bank code, you do not need to enter an IBAN number. You enter BIC for the banks that have it.</p><p>Countries that use bank code are, among others, the United States, Australia, Canada, Russia, New Zealand and South Africa.</p>',
    'kontaktinfo.tittel': 'Contact information',
    'dsop.tittel': 'Disclosure of personal data',
    'dsop.levertedata': 'Delivered data',
    'dsop.kilde': 'Source: DSOP (Norwegian digital collaboration between the public and private sector)',
    'dsop.uthentingstidspunkt': 'Retrieval time',
    'dsop.personnummer': 'Personal identification number (personnummer)',
    'dsop.mottaker': 'Company',
    'dsop.tema': 'Subject',
    'dsop.lastned': 'Download supplied data',
    'dsop.ingendata': merInfo.dsop.info + '<br></br><br></br>No personal data has been disclosed.',
    'inst.tittel': 'Institutional stays',
    'inst.institusjon': 'Institution',
    'inst.detaljer': 'Details',
    'inst.disclaimer':
        'Here you can see information about stays in nursing homes, health institutions and prisons. Institutions are obliged to <lenkeTilInstMelding>send a notification to Nav</lenkeTilInstMelding> about all persons who are registered and discharged. If you notice errors in the information, you must contact the institution directly.',
    'inst.periode': 'Period',
    'inst.institusjonsnavn': 'Name of institution',
    'inst.institusjonstype': 'Type of institution',
    'inst.kategori': 'Category',
    'inst.registreringstidspunkt': 'Date of registration',
    'inst.ingendata': 'No institutional stay is registered',
    'inst.fiktivSluttdato.tittel': 'Termination',
    'inst.fiktivSluttdato': 'The termination of the stay at the institution has not been reported. Nav has automatically terminated the stay.',
    'inst.kilde': 'Source: The individual institution',
    'kontaktinformasjon-kilde': `Where is this contact information from?
  Nav uses your contact information from The common contact register. This is a joint national registry used by the government to send
  messages and documents. You can also register the phone number you want to be reached by in the Nav registry.`,
    'kontaktogreservasjonsregister-disclaimer':
        'You receive mail and information electronically from the government. This is because you have not opted out of electronic communication.',
    'kontaktogreservasjonsregister-disclaimer-reservert':
        'You receive important letters from the government in the mail. This is because you have reserved yourself against electronic communication. The state and municipality can still send you other information by e-mail, SMS or as a digital letter.',
    'medl.tittel': 'Membership of the National Insurance Scheme',
    'medl.ingendata': 'You have no registered periods.',
    'medl.oversikt.ingress':
        'If you work and live in Norway, you are normally a member of the National Insurance Scheme. Periods with this type of membership will not be shown in this page. This page is only relevant if you have',
    'medl.oversikt.1': 'lived, worked or studied abroad, and you have applied for membership in the National Insurance Scheme.',
    'medl.oversikt.2': 'worked in Norway, but were a member of a different countries National Insurance Scheme.',
    'medl.situasjoner.tittel': 'Different scenarios',
    'medl.situasjoner.1':
        'If you move abroad to live or work, membership in the National Insurance Scheme depends on what you do and how long you stay.',
    'medl.situasjoner.2':
        'Norwegian students will normally be compulsory members of the National Insurance Scheme, if they receive funding from the State Educational Loan Fund (Lånekassen) to study at universities abroad.',
    'medl.situasjoner.3':
        'If you live in a different country, but work full time or part time in Norway, you may join the national insurance scheme in the country you live and be exempt from membership in the National Insurance Scheme in Norway.',
    'medl.folketrygden.tittel': 'What does membership in the National Insurance Scheme mean?',
    'medl.folketrygden.ingress':
        'Membership in the National Insurance Scheme is the key to eligibility for rights to services from Nav. <lenkeTilFolketrygden> Read about membership in the National Insurance Scheme</lenkeTilFolketrygden>. Contact Nav if you have questions about periods with membership or exemptions from membership in the National Insurance Scheme, telephone (+47) 21 07 37 00.',
    'medl.folketrygden.lanekassen':
        'Contact the State Educational Loan Fund (Lånekassen) if you have questions about periods with funding while studying abroad.',
    'medl.perioder.tittel': 'Overview of periods',
    'medl.perioder.alert': 'Only periods registered from 2015 are available in this overview.',
    'medl.medlemskap.med.tittel': 'With membership',
    'medl.medlemskap.med.ingress':
        'This overview shows periods where you have applied to Nav for membership in the National Insurance Scheme and received confirmation of it.',
    'medl.medlemskap.uten.tittel': 'Exemptions from membership',
    'medl.medlemskap.uten.ingress':
        'The overview shows periods where Nav has received information from the social security authority in another country that you were part of the social security scheme in your country of residence while you worked in Norway.',
    'medl.medlemskap.lanekassen.tittel': 'With support from the State Educational Loan Fund to study abroad',
    'medl.medlemskap.lanekassen.ingress':
        'The overview shows periods where the State Educational Loan Fund (Lånekassen) has registered you as a student at a foreign educational institution.',
    'medl.periode': 'Period',
    'medl.trygdedekning': 'Coverage',
    'medl.trygdedekning.hjelpetekst': 'Information about what kind of membership in the National Insurance Scheme you have.',
    'medl.lovvalgsland': 'Country',
    'medl.lovvalgsland.hjelpetekst': `Information about which country's social security scheme you were part of, during the
    period you were exempt from membership in the National Insurance Scheme.`,
    'medl.hjemmel': 'Legal basis',
    'medl.hjemmel.hjelpetekst':
        'Information about the basis for your membership in the National Insurance Scheme (law or agreement). If you are exempt from membership in the National Insurance Scheme, it shows the basis for the exemption.',
    'medl.statsborgerland': 'Citizenship',
    'medl.studieland': 'Country of studies',
    'dittnavkontor.tittel': 'Your Nav office',
    'dittnavkontor.beskrivelse': `If you are already receiving follow-up at a Nav office, you should continue to use this office.
    If you don't get follow-up, you can use the office below.`,
    'dittnavkontor.ingress': 'Your office is ',
    'dittnavkontor.select.label': 'Nav office',
    'dittnavkontor.postadresse': 'Postal address',
    'dittnavkontor.postboks': 'Mailbox',
    'dittnavkontor.publikumsmottak': 'Public reception area',
    'dittnavkontor.publikumsmottakfor': 'Public reception area for',
    'dittnavkontor.apningstider': 'Opening hours',
    'dittnavkontor.spesielleapningstider': 'Special opening hours',
    'dittnavkontor.kontaktinfo.overskrift': 'Contact Nav',
    'dittnavkontor.kontaktinfo.lenke': 'Go to contact information',
    'dittnavkontor.kilde': 'National Population Register ',
    'lenker.tittel': 'More information about you',
    'lenker.beskrivelse':
        'We also have information about you that you do not see on this page. Go to the various services below and see information.',
    'lenker.pensjon.tittel': 'Pension rights (text in norwegian)',
    'lenker.pensjon.beskrivelse': 'See your pension rights and calculate your retirement pension',
    'lenker.pensjon.lenkeTekst': 'Go to Your pension',
    'lenker.sykefravaer.tittel': 'Your sickness absence (text in norwegian)',
    'lenker.sykefravaer.beskrivelse': 'See your sickness absence and medical certificates (sykemeldinger)',
    'lenker.sykefravaer.lenkeTekst': 'Your cases',
    'lenker.dokumentarkiv.tittel': 'Document archive',
    'lenker.dokumentarkiv.beskrivelse': 'See an overview of your documents',
    'lenker.utbetalinger.tittel': 'Payments (text in norwegian)',
    'lenker.utbetalinger.beskrivelse': 'See your payments from Nav (payments from the municipality are not displayed)',
    'lenker.cv.tittel': 'CV (text in norwegian)',
    'lenker.cv.beskrivelse': 'See your CV',
    'lenker.stillingssok.tittel': 'Job search (text in norwegian)',
    'lenker.stillingssok.beskrivelse': 'Your saved searches for positions',
    'lenker.dsop.tittel': 'Disclosure of personal data',
    'lenker.dsop.beskrivelse': 'See what information Nav shares with insurance companies and pension schemes',
    'lenker.dsop.info': merInfo.dsop.info,
    'lenker.inst.tittel': 'Institutional stays',
    'lenker.inst.beskrivelse': 'See your institutional stays',
    'lenker.medl.tittel': 'Membership and exemption from membership in the National Insurance Scheme',
    'lenker.medl.beskrivelse':
        "See periods where you've stayed abroad, and periods where you have worked in Norway, and lived in a different country",
    'lenker.fullmakt.tittel': 'Powers of attorney (text in norwegian)',
    'lenker.fullmakt.beskrivelse': 'See your powers of attorney',
    'lenker.skjerming.tittel': 'Protection against access (text in norwegian)',
    'lenker.skjerming.beskrivelse': 'Applies to employees of Nav and family members',
    'felter.type.label': 'Type',
    'felter.type.velg': 'Select type',
    'felter.merom': 'More about',
    'felter.prioritet.label': 'Priority',
    'felter.prioritet.velg': 'Choose priority',
    'felter.landkode.label': 'Country code',
    'felter.tlfnr.label': 'Telephone number',
    'felter.adressetype': 'Type of address',
    'felter.adressetype.gateadresse': 'Road and place address',
    'felter.adressetype.postboksadresse': 'Mailbox address',
    'felter.adressetype.stedsadresse': 'Place address',
    'felter.adressevalg.norsk': 'Norwegian address',
    'felter.adressevalg.utenlandsk': 'Foreign address',
    'felter.tilleggslinje.label': 'C/O (optional)',
    'felter.postbokseier.label': 'Mailbox owner (optional)',
    'felter.tilleggslinje.placeholder': ' ',
    'felter.gatenavn.label': 'Street name',
    'felter.gatenummer.label': 'Number',
    'felter.gatebokstav.label': 'Letter',
    'felter.bolignummer.label': 'Unit number',
    'felter.gyldigtom.label': 'Valid until',
    'felter.postnummer.label': 'Postal code',
    'felter.tilleggsnavn.label': 'Additional address name (optional)',
    'felter.postboks.label': 'Mailbox',
    'felter.postboksnummer.label': 'Mailbox number',
    'felter.postboksanlegg.label': 'Mailboxes (optional)',
    'felter.stedsadresse.label': 'Place address',
    'felter.adresse.label': 'Address',
    'felter.bygningetasjeleilighet.label': 'Building (optional)',
    'felter.regiondistriktomraade.label': 'Region (optional)',
    'felter.postkode.label': 'Postal code (optional)',
    'felter.bysted.label': 'City / Place name (optional)',
    'felter.bankens.adresse.label': 'Bank address',
    'felter.land.label': 'Country',
    'felter.kontonummer.label': 'Account number',
    'felter.kontonummer.grouplegend': 'Choose Norwegian or foreign account number',
    'felter.kontonummervalg.norsk': 'Norwegian account number',
    'felter.kontonummervalg.utenlandsk': 'Foreign account number',
    'felter.utenlandskkonto.info':
        'Be careful when you fill in bank information for foreign accounts so that the payment arrives at the correct location. Nav is not responsible for ensuring that the information is correct. Fees may apply. Read more about requirements for <a> foreign account numbers </a>.',
    'felter.kontonummer.kontonummer.label': 'Account number / IBAN',
    'felter.bic.label': 'BIC / SWIFT code',
    'felter.bankensland.label': 'Country of bank',
    'felter.valuta.label': 'Currency',
    'felter.bankkode.label': 'Bank code',
    'felter.banknavn.label': 'Name of bank',
    'felter.bankidentifier.bic': 'BIC / SWIFT code',
    'felter.bankidentifier.bankkode': 'Bank code',
    'felter.bankidentifier.harikke.bic': 'Do not have BIC / SWIFT code',
    'felter.bankidentifier.harikke.bic.advarsel': 'If you do not provide the BIC / SWIFT code, the payment may be delayed or rejected.',
    'felter.landetbrukerbankkode.advarsel':
        'For <span>{land}</span> you can provide both BIC/SWIFT code and bank code. You can provide both, but one code is sufficient.',
    'validation.only.letters': 'Enter only letters',
    'validation.only.digits': 'Enter only numbers',
    'validation.postboks.pakrevd': 'Mailbox is required',
    'validation.coadressenavn.pakrevd': 'Fill in name of recipient or remove selected type from drop-down menu',
    'validation.only.digits.space': 'Enter only numbers and spaces',
    'validation.only.letters.and.digits': 'Enter only letters and numbers',
    'validation.only.letters.space.and.digits': 'Enter only letters, spaces and numbers',
    'validation.min.one.letter': 'Enter at least one letter',
    'validation.without.space': 'Spaces are not allowed',
    'validation.gatenavn.pakrevd': 'Street name is required',
    'validation.gatenavn.valid': 'Enter only letters and full stops',
    'validation.husnummer.pakrevd': 'Required',
    'validation.husnummer.positive': 'Invalid',
    'validation.type.pakrevd': 'Type is required',
    'validation.prioritet.pakrevd': 'Priority is required',
    'validation.tlfnr.pakrevd': 'Phone number is required',
    'validation.tlfnr.siffer': 'Phone numbers must be numbers',
    'validation.tlfnr.norske': 'Norwegian phone numbers must have 8 numbers',
    'validation.tlfnr.makslengde': 'The phone number can have a maximum of 16 numbers',
    'validation.tlfnr.eksisterer': 'This phone number is already registered',
    'validation.retningsnr.pakrevd': 'Area code is required',
    'validation.postnummer.pakrevd': 'Postal code is required',
    'validation.postboksnummer.pakrevd': 'Required',
    'validation.tomdato.pakrevd': 'Valid date is required',
    'validation.tomdato.ugyldig': 'Invalid date',
    'validation.tomdato.fremitid': 'Select a date forward in time',
    'validation.tomdato.maksetarfrem': 'Select a date maximum 1 year ahead',
    'validation.gateadresse.pakrevd': 'Street address is required',
    'validation.stedsadresse.pakrevd': 'Place address is required',
    'validation.land.pakrevd': 'Country is required',
    'validation.bankidentifier.pakrevd': 'You must select an option',
    'validation.bankidentifier.valid': 'If you fill out the IBAN number, you must also fill out the BIC / SWIFT code',
    'validation.kontonummer.pakrevd': 'Account number is required',
    'validation.kontonummer.elleve': 'Norwegian account numbers must have 11 numbers',
    'validation.kontonummer.mod11': 'Enter a valid account number',
    'validation.kontonummer.idnr': 'Account number cannot be a national identity number or D-number.',
    'validation.ikke.iban': 'US account numbers cannot be IBAN',
    'validation.iban.pakrevd': 'IBAN is required',
    'validation.iban.gyldig': 'Valid IBAN is required',
    'validation.iban.country': 'You must enter an IBAN number from the country you have selected.',
    'validation.banknavn.pakrevd': 'Bank name is required',
    'validation.banknavn.ugyldig': 'Contains invalid characters',
    'validation.bankkode.pakrevd': 'Bank code required',
    'validation.bankkode.lengde': 'Bank codes from {land} must have {siffer} numbers',
    'validation.bic.pakrevd': 'BIC / SWIFT-code is required',
    'validation.bic.gyldig': 'Valid BIC / SWIFT code is required',
    'validation.bic.country': 'You must enter a valid BIC / SWIFT code from the country you have selected.',
    'validation.valuta.pakrevd': 'Currency is required',
    'validation.adresse.pakrevd': 'Address is required',
    'validation.adresselinje.pakrevd': 'Required when the field below is filled in',
    'validation.adresselinje.ugyldig': 'Contains invalid characters',
    'validation.svarteliste.felles': 'Cannot contain words such as «ukjent», «ikke kjent», «vet ikke», «uoppgitt», «n.n.», «nomen nescio»',
    'validation.bolignummer.ugyldig': 'Unit number consists of one letter (L, H, U or K) and four numbers.',
    'validation.firstchar.notspace': 'The first letter cannot be a space',
    'validation.multiple.spaces': 'Cannot have multiple contiguous spaces',
    'validation.only.space.signs.or.digits': 'Cannot consist of space, special characters and / or numbers only',
    'validation.only.space.or.signs': 'Cannot consist of space and / or special characters only',
    'validation.fix.errors': 'To proceed, you must correct the following:',
    'alternativer.tittel': 'More information',
    'alternativer.feilopplysninger.tittel': merInfo.feilopplysninger.tittel,
    'alternativer.feilopplysninger.melding': merInfo.feilopplysninger.melding,
    'alternativer.savneropplysninger.tittel': merInfo.savneropplysninger.tittel,
    'alternativer.savneropplysninger.melding': merInfo.savneropplysninger.melding,
    'alternativer.utlevere.tittel': merInfo.utlevere.tittel,
    'alternativer.utlevere.melding': merInfo.utlevere.melding,
    'alternativer.klage.tittel': merInfo.klage.tittel,
    'alternativer.klage.melding': merInfo.klage.melding,
    'select.sok': 'Search ...',
    'select.loading': 'Loading ...',
    'select.no.hits': 'No hits for',
    'endreKontonummer.tittel': 'Change account number for payment',
    'endreKontonummer.info':
        'You can not change the account number for payments from the municipality, such as financial assistance. <lenkeNavno>Change account number for payments from the municipality.</lenkeNavno>',
    'endreKontonummer.lenkeURL': 'https://www.nav.no/kontonummer/en#kommune',
    'endreKontonummer.authInfo': 'You will be asked to log in again to confirm the change.',
    'endreKontonummer.success':
        '<p>Your bank account has been changed.</p><p>Nav will send you a notification of the change by SMS and/or e-mail.</p>',
    'endreKontonummer.error': 'An error occurred while changing the account number.',
    'utbetalinger.info':
        'If you do not recognize the bank account number, you must phone <tlfTilKontaktsenter>55 55 33 33</tlfTilKontaktsenter> in the opening hours, or <lenkeTilKontaktOss>contact us</lenkeTilKontaktOss> in our digital channels.',
};
